export default {
  'menu.welcome': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',

  // 建銀智能評価システムメニュー
  'menu.operations': '運営概況',
  'menu.customer': '顧客管理',
  'menu.customer.customerAdd': '顧客追加',
  'menu.customer.customerEdit': '顧客編集',
  'menu.task': 'タスク管理',
  'menu.report': 'レポート管理',
  'menu.activity': 'アクティビティ管理',
  'menu.finance': '財務管理',
  'menu.platform': 'プラットフォーム保守',
  'menu.netValueSolution': '純資産プラン',
  'menu.ledger': '台帳管理',
  'menu.system': 'システム管理',

  // システム管理サブメニュー
  'menu.organization': '組織管理',
  'menu.logs': '操作ログ',
  'menu.user': 'ユーザー管理',
  'menu.personal': '個人設定',
  'menu.role': 'ロール管理',
  'menu.settings': 'システム設定',

  // 完全なシステム管理サブメニューパス
  'menu.system.organization': '組織管理',
  'menu.system.organizationAdd': '組織追加',
  'menu.system.organizationEdit': '組織編集',
  'menu.system.organizationView': '組織詳細',
  'menu.system.logs': '操作ログ',
  'menu.system.user': 'ユーザー管理',
  'menu.system.userCreate': 'ユーザー追加',
  'menu.system.userEdit': 'ユーザー編集',
  'menu.system.personal': '個人設定',
  'menu.system.role': 'ロール管理',
  'menu.system.roleCreate': 'ロール追加',
  'menu.system.permission': '権限管理',
  'menu.system.menu': 'メニュー設定',
  'menu.system.settings': 'システム設定',

  // 完全な顧客管理サブメニューパス
  'menu.customer.customerView': '顧客詳細',
  'menu.customer.customerUserCreate': '顧客ユーザー追加',
  'menu.customer.customerUserEdit': '顧客ユーザー編集',

  // 完全なタスク管理サブメニューパス
  'menu.task.taskMyTask': 'マイタスク',
  'menu.task.taskStatistics': 'タスク統計',
  'menu.task.taskSupplement': 'タスク補足',
  'menu.task.taskCreate': 'タスク作成',
  'menu.task.reportReview': 'マイレビュー',
  'menu.task.reportDetail': 'レポート詳細',

  // 完全なレポート管理サブメニューパス
  'menu.report.reportStatistics': 'レポート統計',
  'menu.report.reportDetail': 'レポート詳細',

  // 純資産プラン サブメニュー
  'menu.netValueSolution.netValueSolutionAdd': '純資産プラン追加',
  'menu.netValueSolution.netValueSolutionList': '純資産プラン一覧',
  'menu.netValueSolution.netValueSolutionCommonParams': '共通パラメータ管理',
  'menu.netValueSolution.netValueSolutionPlanCustomParams':
    'プランカスタムパラメータ',
  'menu.netValueSolutionAdd': '純資産プラン追加',
  'menu.netValueSolutionList': '純資産プラン一覧',
  'menu.netValueSolutionCommonParams': '共通パラメータ管理',
  'menu.netValueSolutionPlanCustomParams': 'プランカスタムパラメータ',

  // 台帳管理 サブメニュー
  'menu.ledger.ledgerList': '台帳明細',
  'menu.ledgerList': '台帳明細',
  'menu.ledger.ledgerInquiry': '見積台帳',
  'menu.ledgerInquiry': '見積台帳',
  'menu.ledger.ledgerEdit': '台帳編集',
  'menu.ledgerEdit': '台帳編集',
};
